import * as tslib_1 from "tslib";
import { isWeixin } from '@ivy/fts/utils';
import { wxConfigReady } from '@ivy/fts/weixin';
import { Component, Vue } from 'vue-property-decorator';
import ExchangeCode from '../comps/exchangeCode.vue';
import { uploadEvent } from '@/api/goods/statistics';
import * as MicroUtils from '../shop/utils';
import { env } from '@ivy/fts/envInfo/envInfo';
let PayDone = class PayDone extends Vue {
    constructor() {
        super(...arguments);
        this.goldShow = false;
        this.courseType = null; //主要为了区分社群正式课
        this.tid = null;
        this.qrcode = null; // 空格占位
        this.spuId = null;
        this.detailTextTip = '';
        this.banner = [];
        this.flag = true;
        this.swipeIndex = 0;
        this.swiperSpeed = 800;
        this.url = require('../../assets/download-ivy.png');
        this.exchangeShow = false;
        this.exchangeObj = {};
        this.titleContent = '购买成功';
        this.openAccess = false;
        this.helperInfo = {};
        this.courseInfo = {};
        this.courseSleep = false;
        this.showBox = false;
        this.hide_helper = true;
        this.goodsItems = [];
        this.goldInfo = null;
    }
    get qrcodeStyle() {
        return this.qrcode ? {} : { height: 0, overflow: 'hidden', opacity: 0 };
    }
    get showFormalPayDone() {
        return this.courseType === 'formal' && !!this.qrcode;
    }
    get courseStartTime() {
        const courseInfo = this.courseInfo;
        const startTime = (courseInfo && courseInfo.auth && courseInfo.auth.start_time) || '';
        if (!startTime)
            return '';
        // new Date('2017-02-16 20:41:10') 类似这种写法ios移动端不兼容！！！必须替换 "-" 为 "/"
        const timeStemp = new Date(startTime.replace(/-/g, '/'));
        const Y = timeStemp.getFullYear();
        const M = timeStemp.getMonth() + 1;
        const D = timeStemp.getDate();
        return `开课时间： ${Y}年${M >= 10 ? M : `0${M}`}月${D >= 10 ? D : `0${D}`}日`;
    }
    async created() {
        await this.$store.login();
        if (isWeixin()) {
            await wxConfigReady();
        }
        if (!this.$route.query.tid || this.$route.query.tid === 'undefined') {
            await this.getCodeByAccess();
        }
        else {
            this.init();
        }
        await uploadEvent.init();
        // 电商埋点-支付成功页曝光
        uploadEvent.sendRecord('Exposure_PaySucess', '', { FromPage: 1, tid: this.$route.query.tid }, [
            ['p1', 'FromPage'],
            ['p2', 'tid'],
        ]);
    }
    async init() {
        let exchangeCode = await this.$axios.get('/api/goods/order/order/getInfoAfterPaid', {
            params: {
                tid: this.$route.query.tid,
            },
        });
        this.goldInfo = exchangeCode.data.gold || {
            received: true,
            amount: 999,
        };
        this.exchangeObj = exchangeCode.data;
        this.exchangeShow = exchangeCode.data.has_third_code;
        // FIXME 这是个通用页面 this.$route.query里面只能用tid,其他参数禁止使用
        if (this.$route.query.tp && this.$route.query.tp === 'exchangeCode') {
            this.titleContent = '兑换码';
        }
        if (this.exchangeShow) {
            this.detailTextTip =
                '*您购买的商品包含兑换码，请复制下方兑换码并按照兑换流程进行兑换';
        }
        let tid = this.$route.query.tid || '';
        this.tid = tid.replace(/(_presell_\d)\w*/, '');
        let { data } = await this.$axios.get(`/api/goods/shop/search/order/getOrderGoodsScopes`, {
            params: {
                tid: this.tid,
            },
        });
        this.goodsItems = data.items || [];
        this.goldShow = data.pay_type === 'gold';
        this.memId = data.mem_id;
        this.appId = data.appid;
        this.banner = data.banner;
        this.courseType =
            (data.course_operate_types && data.course_operate_types[0]) || true;
        data.skus &&
            data.skus.length &&
            data.skus.forEach(v => {
                if (v.type === 'course' || v.type === 'knowlege') {
                    this.spuId = v.spu_id;
                    return;
                }
            });
        this.spuId = this.spuId || +this.$route.query.spuId;
        const { data: hide_helper_spu } = await this.$axios.get('/api/mobile/other/setting/getSetting', {
            params: {
                key: 'hide_helper_spu',
                cat: 'GOODS',
            },
            disableAlert: true,
        });
        console.log('dddd', hide_helper_spu);
        this.hide_helper = hide_helper_spu.includes(this.spuId);
        if (data.assistants && data.assistants[0]) {
            // 英语课直接在assistant中，亲子课在assistants[0].assistant中
            this.qrcode =
                data.assistants[0].pic_url ||
                    (data.assistants[0].assistant && data.assistants[0].assistant.pic_url);
        }
        let { data: code } = await this.$axios.get(`/api/m-course/crm/crmUpdateRegister`, {
            params: {
                tid: this.tid,
            },
        });
        this.qrcode = code.qr_code_url || this.qrcode;
        this.helperInfo = code.helper_info;
        this.showBox = true;
        if (this.courseType === 'formal' && code.course_info) {
            const { data: courseInfo } = await this.$axios.get(`/api/m-course/course/getUserCourse?course_id=${code.course_info.id}`);
            this.courseInfo = courseInfo;
            this.courseInfo.short_sub_title =
                this.courseInfo.sub_title && this.courseInfo.sub_title.length > 12
                    ? this.courseInfo.sub_title.slice(0, 12) + '...'
                    : this.courseInfo.sub_title;
            this.courseInfo.short_title =
                this.courseInfo.title && this.courseInfo.title.length > 10
                    ? this.courseInfo.title.slice(0, 10) + '...'
                    : this.courseInfo.title;
            this.courseSleep = courseInfo.auth.status === 3;
        }
        if (data.couponInfo && data.couponInfo.discount_price) {
            this.$Toast(`恭喜您获得一张${data.couponInfo.discount_price}元指定商品优惠券，已发放到您的账户内。`);
        }
        this.$title('购买成功');
    }
    async getCodeByAccess() {
        const { openAccess, subject, launch_id, course_id } = this.$route.query;
        this.openAccess = openAccess;
        if (openAccess) {
            let { data: code } = await this.$axios.get(`/api/crm/register/register/getDirectlyOpenAuthQrcode?course_id=${course_id}&launch_id=${launch_id}&subject=${subject}`);
            this.qrcode = code.qr_code_url || this.qrcode;
        }
    }
    beforeChange(index) {
        this.flag = false;
    }
    endChange(index) {
        this.flag = true;
        this.swipeIndex = index;
    }
    async skip(url) {
        if (!this.flag) {
            return;
        }
        if (url.includes('h5')) {
            return (window.location.href = decodeURIComponent(url.replace('ivydadreadtool://h5?url=', '')));
        }
        else {
            MicroUtils.goLink(url, env);
        }
        // if (this.swipeIndex === this.banner.length - 1) {
        //   this.swiperSpeed = 80000 // 这里是为了解决 oppApp() 方法触发可能有2秒延迟，导致的轮播图轮播用户体验很差
        //   return await openApp()
        // } else {
        //   window.location.href = this.banner[this.swipeIndex].skip
        // }
    }
    async toHome() {
        // 电商埋点-支付成功页点击返回首页
        await uploadEvent.sendRecord('Click_PaySucess_Finish', '', this.goodsItems
            .filter(e => e.goods_type !== 'goods_gift')
            .reduce((t, c, i) => {
            t.GoodsName += i === 0 ? `${c.goods_title}` : `_${c.goods_title}`;
            t.SkuID += i === 0 ? `${c.goods_id}` : `_${c.goods_id}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
        let url = `http://m.ivydad.com.cn/center/`;
        if (window.location.protocol === 'https:') {
            url = `https://m.ivydad.com/center/`;
        }
        window.location.replace(url);
    }
    async toDetail() {
        // 电商埋点-支付成功页点击查看详情
        await uploadEvent.sendRecord('Click_PaySucess_ViewDetail', '', this.goodsItems
            .filter(e => e.goods_type !== 'goods_gift')
            .reduce((t, c, i) => {
            t.GoodsName += i === 0 ? `${c.goods_title}` : `_${c.goods_title}`;
            t.SkuID += i === 0 ? `${c.goods_id}` : `_${c.goods_id}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
        this.$router.push({
            path: `/orderDetail`,
            query: {
                tid: this.tid,
            },
        });
    }
    goGoldShop() {
        window.location.href = window.location.origin + '/invitation/coinmall';
    }
};
PayDone = tslib_1.__decorate([
    Component({
        components: {
            ExchangeCode,
        },
    })
], PayDone);
export default PayDone;
